module.exports = __webpack_public_path__ + "static/media/description.79267ab3.jpeg";